import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-asset-settings-dialog',
  templateUrl: './asset-settings-dialog.component.html',
  styleUrls: ['./asset-settings-dialog.component.scss'],
})
export class AssetSettingsDialogComponent {
  constructor(
    private _formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  AssetSettingForm = this._formBuilder.group({
    assetId: this.data.assetDetails.assetId,
    assetName: this.data.assetDetails.assetName,
    assetType: this.data.assetDetails.assetType,
    assetUrl: this.data.assetDetails.assetUrl,
    intrusion: this.data.assetDetails.intrusion,
    animalDetection:
      this.data.assetDetails.animalDetection == null
        ? false
        : this.data.assetDetails.animalDetection,
    peopleDetection:
      this.data.assetDetails.peopleDetection == null
        ? false
        : this.data.assetDetails.peopleDetection,
    vehicleDetection: this.data.assetDetails.vehicleDetection,
    fullFrame: this.data.fullFrame = this.data.assetDetails.fullFrame,
    fire: this.data.assetDetails.fire,
    anpr: this.data.assetDetails.anpr,
    faceRecognization: this.data.assetDetails.faceRecognization,
  });
  alertFormValues(formGroup: FormGroup) {
    alert(JSON.stringify(formGroup.value, null, 2));
  }
  onSaveSubmit() {
    const assetSettings = {
      assetId: this.data.assetId,
      assetName: this.data.assetName,
      assetType: this.data.assetType,
      assetUrl: this.data.assetUrl,
      // enableIntrusion: this.AssetSettingForm.controls.enableIntrusion.value,
      // enablePeopleDetect:
      //   this.AssetSettingForm.controls.enablePeopleDetect.value,
      // enableVehicleDetect:
      //   this.AssetSettingForm.controls.enableVehicleDetect.value,
      // enableFire: this.AssetSettingForm.controls.enableFire.value,
    };
  }
}
